import React from 'react';
import SelectionButtonNew from '@src/components/SelectionButtonNew';
import { LibraryMusicRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';

const AdjustAudio = ({
  isMoreButton,
  synthesisRequest,
  outputAudioTypes,
  handleChangeSynthesisRequest,
  handleCloseSearchBoxAndMoreMenu,
  handleCloseSearchBox,
}) => (
  <div
    className={`group group-adjust-audio ${
      isMoreButton && 'group-adjust-audio-more-button'
    }`}
  >
    <SelectionButtonNew
      openAttribute="open-audio-type-menu"
      attribute="select-audio-type"
      currentValue={synthesisRequest.audioType}
      name="audioType"
      tooltipTitle="changeAudioFormat"
      icon={
        <LibraryMusicRounded sx={{ fontSize: 24, color: COLOR.navyBlue }} />
      }
      options={outputAudioTypes}
      width="70px"
      onChange={handleChangeSynthesisRequest}
      handleCloseSearchBoxAndMoreMenu={handleCloseSearchBoxAndMoreMenu}
      handleCloseSearchBox={handleCloseSearchBox}
      isMoreButton={isMoreButton}
      useNewUiChangeType
    />
  </div>
);

export default AdjustAudio;
